module.exports = __webpack_public_path__ + "img/10.0208f5e9.jpg";